import React            from 'react';
import View             from '@widesk-ui/components/View';
import useDesignTokens  from '@/hooks/useDesignTokens';
import HelpTip          from '@/TokamapEditor/ux/AreaSidebar/HelpTip';

export type NormalHoverScope = 'normal' | 'hover';

const OPTIONS: { value: NormalHoverScope; label: string; }[] = [
	{ value: 'normal', label: 'Normal' },
	{ value: 'hover', label: 'Au survol' },
];

export default function NormalHoverToggle({ value, onChange, help }: {
	value: NormalHoverScope;
	onChange: (value: NormalHoverScope) => void;
	/** Explication de l'état choisi, en info-bulle au bout de la rangée. */
	help?: React.ReactNode;
}) {
	const tokens = useDesignTokens();

	return (
		<View row gap={18} style={{ alignSelf: 'flex-start', alignItems: 'flex-start' }}>
			{OPTIONS.map(option => {
				const active = option.value === value;

				return (
					<View
						key={option.value}
						pointer
						bold={active}
						size={13}
						color={active ? tokens.text.default : tokens.text.muted}
						onClick={() => onChange(option.value)}
						hover={active ? undefined : { color: tokens.text.default }}
						style={{
							padding: '2px 0 8px',
							borderBottom: `2px solid ${active ? tokens.color.primary : 'transparent'}`,
						}}
					>
						{option.label}
					</View>
				);
			})}

			{!!help && (
				<View size={13} style={{ padding: '2px 0 8px', marginLeft: -12 }}>
					<HelpTip>{help}</HelpTip>
				</View>
			)}

			{value === 'hover' && (
				<View size={12} color={tokens.color.primary} style={{ padding: '3px 0 8px', marginLeft: -6 }}>
					Aperçu sur la carte
				</View>
			)}
		</View>
	);
}
